import { getValueWithTooltip } from '@dynamika-shared/ui/Table/getValueWithTooltip';
import { CohortType } from '@dynamika-shared/types/cohorts';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { Dropdown } from '@dynamika-shared/ui/Dropdown/Dropdown';
import {
  CohortData,
  MAX_LENGTH_NAME,
  OptionType,
} from 'src/pages/ClinicalTrial/ClinicalTrialVisits/CohortList';
import {
  ArchiveIcon,
  DotsIcon,
  EditSmallIcon,
  TrashIcon,
} from '@dynamika-shared/ui/icons';
import { VisitsControlSchemaType } from 'src/pages/ClinicalTrial/uiControlSchemaByStatus/ControlTypes';

const ICON_PROPS = { width: 24, height: 24 };

export const dropdownItems = [
  {
    key: 'edit',
    label: <div>Edit</div>,
    icon: <EditSmallIcon {...ICON_PROPS} className='text-black' />,
  },
  {
    key: 'archive',
    label: <div>Archive</div>,
    icon: (
      <ArchiveIcon width={18} height={18} className={'ml-[.4rem] pr-[.4rem]'} />
    ),
  },
  {
    key: 'delete',
    label: <div className='text-redOrange'>Delete</div>,
    icon: <TrashIcon {...ICON_PROPS} className='text-redOrange' />,
  },
];

export const transformCohorts = (
  cohorts: CohortType[],
  uiControlSchema: VisitsControlSchemaType,
  addVisitAction: (cohort: CohortType) => void,
  dropDownOnClick: (key: OptionType, cohort: CohortType) => void,
): CohortData => {
  return [...cohorts]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(cohort => ({
      ...cohort,
      unscheduledVisitsAllowed: cohort.unscheduledAllowed ? 'Allowed' : 'Not Allowed',
      numberOfVisits: cohort.visits.length ?? 'n/a',
      disabled: !cohort.visits.length,
      patientCodePattern: getValueWithTooltip(
        'patientCodePattern',
        MAX_LENGTH_NAME
      )(cohort),
      name: getValueWithTooltip('name', MAX_LENGTH_NAME)(cohort),
      status: (
        <div className='capitalize'>{cohort.status?.toLowerCase()}</div>
      ),
      action: (
        <div className='flex justify-end gap-1'>
          {!uiControlSchema.addVisit.hidden && (
            <Button
              iconType='plus'
              iconClassName={'w-2 h-2'}
              type='text'
              className='without-bg'
              onClick={e => {
                e.stopPropagation();
                addVisitAction(cohort);
              }}
              data-testid={`addVisit-${cohort.id}`}
            >
              Visit
            </Button>
          )}
          <div className='ml-1 flex items-center justify-center'>
            {!uiControlSchema.editCohort.hidden &&
              !uiControlSchema.deleteCohort.hidden && (
                <Dropdown
                  items={dropdownItems}
                  overlayClassName={'w-[20rem]'}
                  trigger={['click']}
                  onClick={e => dropDownOnClick(e.key as OptionType, cohort)}
                >
                  <div className='flex h-5 cursor-pointer items-center justify-center'>
                    <div className='rounded-3xl p-1 hover:bg-waterLight'>
                      <DotsIcon className='hover:text-black' data-testid={`dropDown-${cohort.id}`}/>
                    </div>
                  </div>
                </Dropdown>
              )}
          </div>
        </div>
      ),
    })) as unknown as CohortData;
};
